<template>
  <div class="timeout_form_content">
    <formItem
      class="timeout_form_item"
      :form="form"
      :field="fields"
    >
      <template #appointUserIds>
        <div class="flex">
          <el-select
            v-model="form.appointUserIds"
            multiple
            collapse-tags
            filterable
            remote
            :remote-method="getOaUserByName"
            placeholder="请选择指定人群"
            @change="handleChange"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            />
          </el-select>
          <span v-if="form.appointUserIds&&form.appointUserIds.length" class="select_num">已选择{{ form.appointUserIds.length }}人</span>
        </div>
      </template>
    </formItem>
  </div>
</template>

<script>
import formItem from '@/views/configure/ownerRuleConfig/components/formItem.vue';
import { oaUserByName } from '@/api/platform';
import { processingSelectData } from '@/utils/index';
import {
  TIME_UNIT,
  RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE,
  OVERTIME_TYPE,
} from './const';

export default {
  name: 'TimeoutNotification',
  components: { formItem },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userList: [],
      OVERTIME_TYPE,
      firstFetch: true,
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
  },
  created() {
    this.firstFetch = true;
    this.getOaUserByName();
  },
  methods: {
    async getOaUserByName(query) {
      const res = await oaUserByName({ name: query });
      let userList = res.map((item) => ({
        ...item,
        label: `${item.name} ${item.company} ${item.email} ${item.phone}`,
        userName: item.name,
        userPhone: item.phone,
      }));
      if (this.form.appointUsers && this.form.appointUsers.length && this.firstFetch) {
        this.firstFetch = false;
        userList = this.form.appointUsers;
      }
      this.userList = userList || [];
    },
    handleChange(value) {
      if (!value || !value.length) {
        this.form.appointUsers = [];
        return;
      }
      const users = this.form?.appointUsers?.map((item) => item.id) || [];
      if (value.length > users.length) {
        const newId = value.find((t) => !users.includes(t));
        const currentUser = this.userList.find((t) => t.id === newId);
        this.form.appointUsers = [...this.form.appointUsers, currentUser];
      } else {
        const newId = users.find((t) => !value.includes(t));
        const newIndex = this.form.appointUsers.findIndex((i) => i.id === newId);
        this.form.appointUsers.splice(newIndex, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.timeout_form_content{
  max-width: 50%;
}
.select_num{
  margin-left: 12px;
  color: #059E84;
  font-size: 12px;
  width: 80px;
}
::v-deep .timeout_form_item{
  .el-form-item{
    flex-direction: row;
    align-items: center;
    .el-form-item__label{
      padding-bottom: 0px;
      margin-right: 4px;
      width: 100px;
    }
    .el-form-item__content{
      width: 100%;
    }
  }
}
 .new-flex{
    display:flex;
    flex-wrap:wrap;
    .second-title{
      color:#404B5C;
      margin-bottom:8px;
      width:100%;
    }
    ::v-deep .el-form-item{
      margin-right:16px;
      .el-select{
        margin-right:8px;
      }
      .el-input{
        margin-right:8px;
      }
    }
  }
</style>
